<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M22.4378 3H0.777832V7.81333H2.05195V21.05H21.1637V7.81333H22.4378V3ZM19.8896 19.8467H3.32607V7.81333H19.8896V19.8467ZM21.1637 6.61H2.05195V4.20333H21.1637V6.61ZM8.42254 13.83H14.8186C16.2201 13.83 17.3668 12.747 17.3668 11.4233C17.3668 10.0997 16.2201 9.01667 14.8186 9.01667H8.42254C7.02101 9.01667 5.8743 10.0997 5.8743 11.4233C5.8743 12.747 7.02101 13.83 8.42254 13.83ZM8.42254 10.22H14.8186C15.5194 10.22 16.0927 10.7615 16.0927 11.4233C16.0927 12.0852 15.5194 12.6267 14.8186 12.6267H8.42254C7.72177 12.6267 7.14842 12.0852 7.14842 11.4233C7.14842 10.7615 7.72177 10.22 8.42254 10.22Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
